import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/reservation-edit-room-setup-action-types';

import type {Map} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type ReservationEditRoomSetupStore = {
    reservation: Map<unknown, unknown>;
};

const initialState = (): ReservationEditRoomSetupStore => {
    return {
        reservation: Immutable.Map(),
    };
};

const actionsMap: ActionsMap<ReservationEditRoomSetupStore> = {
    [actionTypes.RESERVATION_EDIT_ROOM_SETUP_GET_RESERVATION_SUCCESS]: (state, action) => {
        return {
            reservation: action.data,
        };
    },
    [actionTypes.RESERVATION_EDIT_ROOM_SETUP_DISPOSE_STORE]: () => {
        return initialState();
    },
};

export default createReducer<ReservationEditRoomSetupStore>(initialState(), actionsMap);
